export default __webpack_public_path__ + "static/media/5505.90b37377.png";